import { CalculatorMicrofrontend } from '../microfrontends/CalculatorMicrofrontend';
import { ScrollToOffersButton } from '../stickyButtons/ScrollToOffersButton';
import { useIsDesktop } from '../../hooks/common';
import { useCalculatorHandlers } from './hooks';
import React from 'react';
import { ETestIds } from '../../constants/testIds';

export interface IControlsContainerProps {
  offersCount: number | null;
  offersIsFetching: boolean;
}

export const ControlsContainer: React.FC<IControlsContainerProps> = ({ offersCount, offersIsFetching }) => {
  const isDesktop = useIsDesktop();
  const { onCatchErrorCalculator, onSubmitCalculator, onSendAnalyticsCalculatorEvent } = useCalculatorHandlers();

  return (
    <div data-testid={ETestIds.ControlsContainer}>
      <CalculatorMicrofrontend
        onSubmitCalculatorEvent={onSubmitCalculator}
        onCatchErrorCalculatorEvent={onCatchErrorCalculator}
        onSendAnalyticsCalculatorEvent={onSendAnalyticsCalculatorEvent}
      />
      {!isDesktop && <ScrollToOffersButton offersCount={offersCount} isLoading={offersIsFetching} />}
    </div>
  );
};
